import { render, staticRenderFns } from "./QualityReportsTable.vue?vue&type=template&id=38ab5034&"
import script from "./QualityReportsTable.vue?vue&type=script&lang=js&"
export * from "./QualityReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports